import { useState } from 'react';

import { HintTooltip } from 'components';
import { PasswordValidation } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Box } from 'libs/ui';
import { PasswordRules } from 'modules/auth/setPassword/components';

import { Field } from '../../../forms/changePasswordForm';

interface PasswordSettingsProps {
  passwordType: 'oldPassword' | 'newPassword';
  passwordValidation: PasswordValidation;
}

export const PasswordField = ({
  passwordValidation,
  passwordType,
}: PasswordSettingsProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  return (
    <HintTooltip
      open={open}
      title={
        <PasswordRules
          passwordFieldName={passwordType}
          passwordValidation={passwordValidation}
        />
      }
      onClose={() => {}}
    >
      <Box flex={1}>
        <Field.Password
          allowSubmit
          fullWidth
          autoComplete={
            passwordType === 'oldPassword' ? 'current-password' : 'new-password'
          }
          label={t(`settings.password.${passwordType}.label`)}
          name={passwordType}
          placeholder={t(`settings.password.${passwordType}.placeholder`)}
          onBlur={() => setOpen(false)}
          onFocus={() => setOpen(true)}
        />
      </Box>
    </HintTooltip>
  );
};
